import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "",
    authority: import.meta.env.VITE_AZURE_AUTHORITY || "https://login.microsoftonline.com/common",
    redirectUri: import.meta.env.VITE_REDIRECT_URI || globalThis.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI || globalThis.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",          // Keep sessionStorage for security
    storeAuthStateInCookie: true,             // Enables session persistence across browser tabs and maintains auth state in browsers that clear sessionStorage; improves usability but may reduce security if cookies are accessible.
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Info,
    },
    tokenRenewalOffsetSeconds: 300,           // Refresh access tokens 5 minutes before expiry
    iframeHashTimeout: 10000,                 // Increase timeout for token renewal
  },
};

export const loginRequest = {
  scopes: import.meta.env.VITE_BACKEND_EID_APP_SCOPE ? [import.meta.env.VITE_BACKEND_EID_APP_SCOPE] : []
};
